import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config, _IsUserPremiumFromPartners, } from "@discovery/common-dplus/lib/state";
import { _Col2TemplateId, _Col2ComponentId, } from "@discovery/sonic-api-ng-optics";
import { _MastheadItems, _Taxonomy, _LiveTvVideo, Genre, Description, _CampaignLandingPage, } from "./optics";
import { HeroView } from "./view";
import { useUser, useAds } from "../../utils/hooks";
const getProps = (data) => {
    const genre = Fold.toArray(Genre, data);
    const liveTvVideoDataM = Fold.preview(_LiveTvVideo, data);
    const heroItems = Fold.toArray(_MastheadItems, data);
    const campaignLandingBannerM = Fold.preview(_CampaignLandingPage, data);
    const filteredheroItems = heroItems;
    const descriptionM = Fold.preview(Description, data);
    const taxonomies = Fold.toArray(_Taxonomy, data).filter((item) => {
        const isDefault = M.fromMaybe(item.mobileImg.default, false);
        return isDefault;
    });
    const filteredTaxonomies = taxonomies.filter(({ name }, i, array) => array.findIndex((t) => t.name === name) === i);
    const templateIdM = Fold.preview(_Col2TemplateId, data);
    const componentIdM = Fold.preview(_Col2ComponentId, data);
    return {
        filteredheroItems,
        templateIdM,
        filteredTaxonomies,
        liveTvVideoDataM,
        genre,
        descriptionM,
        campaignLandingBannerM,
        componentIdM,
    };
};
const Hero = ({ filteredheroItems, templateIdM, filteredTaxonomies, liveTvVideoDataM, genre, descriptionM, campaignLandingBannerM, componentIdM, environment, }) => {
    const [configM] = useGlobalState(_Config);
    const { isAnonymous, premiumPackagesM } = useUser();
    const { adsHasValidPackage, enableAds } = useAds();
    const webAuthRedirectionUrl = environment.authService.protocol + "://" + environment.authService.domain;
    //Config
    const parentalLockM = M.chain((x) => x.parentalLock, configM);
    const premiumPackages = M.fromMaybe(premiumPackagesM, [""]);
    const minimumAgeM = M.chain((x) => x.minimumAge, parentalLockM);
    const ageConstraint = M.fromMaybe(minimumAgeM, 0);
    const isAdsEnabled = enableAds && !adsHasValidPackage;
    const featureTogglesM = M.chain((x) => x.featureToggles, configM);
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const enableAdsM = M.chain((x) => x.enableAds, featureTogglesM);
    const adsM = M.chain((x) => x.ads, configM);
    const vastTagM = M.chain((x) => x.vastTag, adsM);
    const shortvastTagM = M.chain((x) => x.shortsVastTag, adsM);
    const imaAdsConfig = {
        vastTag: M.fromMaybe(vastTagM, ""),
        shortsVastTag: M.fromMaybe(shortvastTagM, ""),
        enableAds: isPremiumUserFromPartner
            ? false
            : M.fromMaybe(enableAdsM, false),
    };
    return (React.createElement(HeroView, { heroItems: filteredheroItems.slice(0, 15), autoplay: 5000, templateIdM: templateIdM, componentIdM: componentIdM, premiumPackages: premiumPackages, read: environment, taxonomyItemsListHero: filteredTaxonomies, anonymous: isAnonymous, webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, resizeWidth: window.innerWidth, isAdsEnabled: isAdsEnabled, liveTvVideoDataM: liveTvVideoDataM, genre: genre, descriptionM: descriptionM, imaAdsConfig: imaAdsConfig, campaignLandingBannerM: campaignLandingBannerM }));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, Hero);

